import React, { Component } from 'react';
import Formatters from 'components/grid-addons/formatters';

import ReactDOM from 'react-dom';

/*
 *  This is an abstract class - the component should be extended with a function for getEditorComponent
 *
 *  This class handles the stateful maintenance of the value required by the EditableGrid
 *
 *  -={ Notes on Implementation }=-
 *
 *  The EditableGrid component can receive a custom editor for a cell
 *
 *  However, rather than communicating via props or callbacks, it expects that the component maintains a function
 *  for inspecting the current value held in the component. (getValue)
 *
 *  For the example components it does this by inspecting the current value of a given input node
 *
 *  The handle the various P4 inputs, we keep the current value in state instead of relying on input node values.
 *
 *  The onChange handler updates state to reflect the current value so it can be interrogated at will.
 *
 */

export default class EditorContainerWrapper extends Component {
  // When passed down to the react component as 'ref', will be called back with the component
  setEditorRef(component) {
    this.editorRef = component;
  }

  constructor(props) {
    super(props);

    this.editor = null;
    this.editorRef = {};

    this.setEditorRef = this.setEditorRef.bind(this);
    this.getInputNode = this.getInputNode.bind(this);

    // this.props will be values received from the EditorContainer logic
    // any extra props for the component are decided at render
    const value = this.getValueFromProps(props);
    this.state = Object.assign({}, { currentValue: value });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.value !== prevProps.value && this.state.currentValue === prevProps.value) {
      const value = this.getValueFromProps(this.props);
      this.setState({ currentValue: value });
    }
  }

  onChange(id, newValue) {
    this.setState({ currentValue: newValue }, () => {
      this.props.onCommit();
    });
  }

  getValue() {
    var updated = {};
    let value = this.state.currentValue;
    const { column } = this.props;
    if (column.formatter === Formatters.NumericFormatter && value === '')
      value = column.options && column.options.nullable ? null : 0;
    updated[column.key] = value;

    if (this.getKey) {
      if (updated[this.getKey()]) updated[this.getKey()] = value;
    }
    return updated;
  }

  getInputNode() {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode) return null;
    if (domNode.tagName === 'INPUT') {
      return domNode;
    }
    return domNode.querySelector('input:not([type=hidden])');
  }

  // by default, callback any onBlur from props - can be overridden
  handleBlur(event) {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }

  // Decide which editor to use based on the values in the current row - needs an override
  getEditorComponent() {
    throw 'Method not implemented exception - getEditorComponent ';
  }

  // Decide which editor to use based on the values in the current row - needs an override
  getEditorProps() {
    throw 'Method not implemented exception - getEditorProps ';
  }

  // Defaults to props value but can be overriden
  getValueFromProps(props) {
    if (props.column.getDefaultValue) {
      const defaultValue = this.props.column.getDefaultValue(props.column, props.rowData);
      if ((!props.value || props.value === 0 || props.value === '') && defaultValue) return defaultValue;
    }
    return props.value;
  }

  render() {
    const EditorComponent = this.getEditorComponent();
    const editorProps = this.getEditorProps();

    /* Any value from props is overridden with the current value of state */

    return (
      <EditorComponent
        ref={this.setEditorRef}
        {...this.props}
        {...editorProps}
        includeLabel={false}
        onChangeValue={this.onChange.bind(this)}
        onChange={this.onChange.bind(this)}
        value={this.state.currentValue}
        onBlur={this.handleBlur.bind(this)}
        commit={() => {}}
      />
    );
  }
}
